import styles from "./Template.module.css";
import { MarketComponentTypePlaceholder } from "../../generated/fresh-guard-api";
import parse from "html-react-parser";
import { prepareSvgTemplate } from "../../tools/helpers/SvgTemplateHelper";
import { useEditMarket } from "../../provider/edit-market/EditMarket.hook.ts";
import type TemplateProperties from "./Template.properties.ts";
import { type CSSProperties, useEffect, useRef } from "react";

export default function TemplateView(props: TemplateProperties) {
  const { enableZoom } = useEditMarket();
  const svgRef = useRef<SVGSVGElement>(null);
  const params = new Map<string, string>();
  params.set(
    MarketComponentTypePlaceholder.Color,
    props.marketComponent.marketComponentStatus ?? "",
  );
  params.set(
    MarketComponentTypePlaceholder.Text,
    props.marketComponent.shortDescription ?? "",
  );

  useEffect(() => {
    const svgRefCurrent = svgRef.current;
    let openDialog = true;

    const handleTouchStart = (event: TouchEvent) => {
      openDialog = event.touches.length <= 1;
    };

    const handleTouchMove = () => {
      openDialog = false;
    };

    const handleTouchEnd = (event: TouchEvent) => {
      if (openDialog) {
        handleContextMenu(event);
      }
    };

    const handleContextMenu = (event: MouseEvent | TouchEvent) => {
      if (enableZoom) {
        if (props.onClickOpenDetails) {
          props.onClickOpenDetails(event);
        }
      } else {
        if (props.onClickOpenEdit) {
          props.onClickOpenEdit(event);
        }
      }
    };

    if (svgRefCurrent) {
      svgRefCurrent.addEventListener("contextmenu", handleContextMenu);
      svgRefCurrent.addEventListener("touchstart", handleTouchStart);
      svgRefCurrent.addEventListener("touchend", handleTouchEnd);
      svgRefCurrent.addEventListener("touchcancel", handleTouchEnd);
      svgRefCurrent.addEventListener("touchmove", handleTouchMove);
    }

    return () => {
      if (svgRefCurrent) {
        svgRefCurrent.removeEventListener("contextmenu", handleContextMenu);
        svgRefCurrent.removeEventListener("touchstart", handleTouchStart);
        svgRefCurrent.removeEventListener("touchend", handleTouchEnd);
        svgRefCurrent.removeEventListener("touchcancel", handleTouchEnd);
        svgRefCurrent.removeEventListener("touchmove", handleTouchMove);
      }
    };
  }, [props, enableZoom]);

  return (
    <svg
      ref={svgRef}
      width={props.marketComponent.size?.width}
      height={props.marketComponent.size?.height}
      xmlns="http://www.w3.org/2000/svg"
      className={styles.svg}
      style={
        {
          "--transform": `rotate(${props.marketComponent.orientation}deg)`,
        } as CSSProperties
      }
    >
      {parse(
        prepareSvgTemplate(props.marketComponent.svgTemplate ?? "", params),
      )}
    </svg>
  );
}
